import { render } from "./get_record.vue?vue&type=template&id=c3bf1a34&scoped=true"
import script from "./get_record.vue?vue&type=script&lang=js"
export * from "./get_record.vue?vue&type=script&lang=js"

import "../../../styles/van-sticky-nav.css?vue&type=style&index=0&id=c3bf1a34&scoped=scoped&lang=css"
import "./get_record.vue?vue&type=style&index=1&id=c3bf1a34&scoped=scoped&lang=css"

import exportComponent from "/Users/leaf/Desktop/gmhwork/h5/zksq_H5/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c3bf1a34"]])

export default __exports__